import { render, staticRenderFns } from "./SpOrderAttachmentUpload.vue?vue&type=template&id=6ed11702&scoped=true&"
import script from "./SpOrderAttachmentUpload.vue?vue&type=script&lang=js&"
export * from "./SpOrderAttachmentUpload.vue?vue&type=script&lang=js&"
import style1 from "./SpOrderAttachmentUpload.vue?vue&type=style&index=1&id=6ed11702&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed11702",
  null
  
)

export default component.exports